import { render, staticRenderFns } from "./label_item_code.vue?vue&type=template&id=428603b9&scoped=true&"
import script from "./label_item_code.vue?vue&type=script&lang=js&"
export * from "./label_item_code.vue?vue&type=script&lang=js&"
import style0 from "./label_item_code.vue?vue&type=style&index=0&id=428603b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428603b9",
  null
  
)

export default component.exports